jQuery(document).ready(function($){
  /*
  setTimeout(function(){
    var description = jQuery(".smart-tabs-wrapper div").not(".tabs-hidden-content").find("p").first().text();
    jQuery(".template-product .product__price").append("<div class='short_description'>"+description+"</div>");
  }, 2000);
  */
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        console.log("click");
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight){
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        } 
      });
    }
	
	// Set Cookie for Announcement Bar
	var cookie = Cookies.get('announcement-cookie');
		if(cookie === 'true'){
			jQuery(".announcement-bar").css("display", "none");
			jQuery(".announcement-bar").css("height", 0);
		}else{
			jQuery(".announcement-bar").css("display", "block");
			jQuery(".announcement-bar").css("height", "auto");
		}
		
		jQuery(".announcement-bar strong.close").click(function(){
			Cookies.set('announcement-cookie', 'true', { expires: 1 });
			jQuery(".announcement-bar").css("display", "none");
			jQuery(".announcement-bar").css("height", 0);
		});
	
	
	
	//Write a Review for Review Page
		jQuery( ".custom-review-wrpr #newReviewForm select" )
	  .change(function() {
		var prdct_id = jQuery( "option:selected", this).attr("data-product-id");
		var prdct_name = jQuery( "option:selected", this).text();
		var prdct_url = jQuery( "option:selected", this).val();
		jQuery( ".custom-review-wrpr .custom-prdct-title" ).text(prdct_name);
		jQuery( ".custom-review-wrpr .custom-prdct-title" ).attr("data-product-title", prdct_name);
		jQuery( ".custom-review-wrpr #HulkAppsReviews" ).attr("data-product-id", prdct_id);
		jQuery( ".custom-review-wrpr #HulkAppsReviews" ).attr("data-product-title", prdct_name);
		jQuery( ".custom-review-wrpr #HulkAppsReviews .productHandle" ).val(prdct_id);
		jQuery( ".custom-review-wrpr #HulkAppsReviews .productTitle" ).val(prdct_name);
	  })
	  .trigger( "change" );
	  
	  jQuery("#SearchDrawer .search__input").keyup(function(){
		var search_val = jQuery(this).val();
		if(search_val != ""){
			jQuery(this).addClass("active");
		}else{
			jQuery(this).removeClass("active");
		}
	  });
});